import React, { useState, useEffect } from 'react';
import { useNavigate, useParams, Link } from 'react-router-dom';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, Pagination, Mousewheel } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import fetchData from 'Utilis/request';
import { useAppSelector } from '../store/hooks';
import Loader from 'components/Loader';
const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

interface StoryArticlesProps {
    post_title: string;
    source: string;
    reporter: string;
    images: any[];
}
const useHideHeader = () => {
  useEffect(() => {    
    // Skip during SSR
    if (typeof document === 'undefined') return;
    const header = document.querySelector('header');    
    // Approach 1: Using classList (recommended)
    header?.classList.add('hide-header');
    return () => {
      // Cleanup for classList approach
      header?.classList.remove('hide-header');     
    };
  }, []);
};

const StoryDetails = () => {
     useHideHeader();
    const fooNavHeight = useAppSelector((state: any) => state.categoryNavigation.fooNavHeight || 0);
    const darkMode = useAppSelector((state: any) => state.categoryNavigation.darkmode);
    //  console.log(fooNavHeight, " fooNavHeight")
    const { storySlug } = useParams<{ storySlug: string }>();
    const navigate = useNavigate();
    const [storyData, setStoryData] = useState<StoryArticlesProps>();
    const [loading, setLoading] = useState(true);

    useEffect(() => {    
        const fetchStory = async () => {
            try {
                const response = await fetchData.getResult(`${API_BASE_URL}getWebstoryDetail.php?slug=${storySlug}`) || []; 
              
                if(response){
                    setStoryData(response);
                }                
            } catch (error) {
                console.error('Error fetching story:', error);
            } finally {
                setLoading(false);
            }
        };
        fetchStory();
    }, [storySlug]);

    const handleNextStory = (href: any) => {
        if (href) {
            navigate(href);
        }
    };
    
    if (loading) {
        return <div className="fixed inset-0 flex justify-center items-center"><Loader darkMode={darkMode}/></div>;
    }

    if (!storyData) {
        return <div className="error">Story not found</div>;
    }


 

    return (
        <div className="story-details-container">
            {/* Back Button */}
            <button 
                className="back-button"
                onClick={() => navigate(-1)}
            >
                &larr; Back
            </button>         

            {/* Image Swiper */}
            <div className="story-swiper-container">
                <Swiper
                    modules={[Navigation, Pagination, Mousewheel]}
                    spaceBetween={20}
                    slidesPerView={1}
                    navigation
                    pagination={false}
                    mousewheel
                    className="story-swiper"
                >
                    {storyData.images.map((image, index) => (
                        <SwiperSlide 
                            key={index}
                            onClick={() => {
                                if (index === storyData.images.length - 1 && image.href) {
                                    handleNextStory(image.href);
                                }
                            }}
                            className={index === storyData.images.length - 1 && image.href ? 'last-slide' : ''}
                        >
                            <div className="slide-content relative">
                                
                                <Link to={`${image?.href ? (image?.href):('')}`}>
                                <img 
                                    src={image.image} 
                                    alt={image.meta_detail} 
                                    className="story-image w-full h-full object-cover"
                                />
                                
                                <div className={`image-caption absolute left-0 right-0 px-4 bg-gradient-to-t from-black/80 to-transparent`} style={{bottom:fooNavHeight, zIndex:1}}>
                                    <div className="text-container bg-black/30 backdrop-blur-sm p-4 rounded-lg">
                                        <p className="text-white text-lg font-medium">{image.meta_detail}</p>
                                        {index === storyData.images.length - 1 && image.href && (
                                            <div className="next-story-prompt mt-2 bg-red-600 text-white px-3 py-1 rounded-md inline-block">
                                                <p className="text-sm font-semibold">Tap to view next story</p>
                                            </div>
                                        )}
                                        {index === storyData.images.length - 1 && (
                                            <div className="story-source mt-2 text-white text-opacity-80 text-sm">
                                                <p>{storyData.source}</p>
                                                <p>Reporter: {storyData.reporter}</p>
                                            </div>
                                        )}
                                    </div>
                                </div>
                                </Link>
                                
                            </div>
                        </SwiperSlide>
                    ))}
                </Swiper>
            </div>
        </div>
    );
};

export default StoryDetails;